"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gasList = exports.ariaList = exports.familyStructureList = exports.ageList = void 0;
exports.ageList = [
    "10代",
    "20代",
    "30代",
    "40代",
    "50代",
    "60代",
    "70代以上",
];
exports.familyStructureList = [
    "一人暮らし",
    "配偶者と同居",
    "配偶者・子どもと同居",
    "子どもと同居",
    "親・配偶者と同居",
    "親・配偶者・子どもと同居",
    "親・子どもと同居",
    "その他",
];
exports.ariaList = [
    "広島市中区",
    "広島市東区",
    "広島市南区",
    "広島市西区",
    "広島市安佐南区",
    "広島市安佐北区",
    "広島市安芸区",
    "広島市佐伯区",
    "呉市",
    "竹原市",
    "三原市",
    "尾道市",
    "福山市",
    "府中市",
    "三次市",
    "庄原市",
    "大竹市",
    "東広島市",
    "廿日市市",
    "安芸高田市",
    "江田島市",
    "安芸郡",
    "山県郡",
    "豊田郡",
    "世羅郡",
    "神石郡",
    "その他",
];
exports.gasList = [
    "安芸農業協同組合 ガスセンター",
    "広島ゆたか農業協同組合 グリーンセンター",
    "尾道市農業協同組合 ＬＰＧ供給センター",
    "株式会社農協プロパンセンター",
    "株式会社広島中央クミアイ燃料",
    "株式会社三次クミアイ燃料",
    "株式会社広島クミアイ燃料 本社ガスセンター",
    "株式会社広島クミアイ燃料 佐伯ガスセンター",
    "株式会社広島クミアイ燃料 三原ガスセンター",
    "株式会社広島クミアイ燃料 安芸高田ガスセンター",
    "株式会社広島クミアイ燃料 庄原ガスセンター",
    "その他",
];
